var coll = document.getElementsByClassName("f-collapsibleuz");
  var i;
  for (i = 0; i < coll.length; i++) {
   coll[i].addEventListener("click", function() {
   this.classList.toggle("active");
   var content = this.nextElementSibling;
    if (content.style.maxHeight){
      content.style.maxHeight = null;
    } else {
      content.style.maxHeight = content.scrollHeight + "px";
    } 
  });
}
$('.myslider').slick({
  slidesToScroll: 1,
  arrows: false,
  autoplay: true,
  autoplaySpeed: 2500,
  dots: false,
  infinite: true,
  vertical: true,
  verticalSwiping: true
});